module.exports = __webpack_public_path__ + "static/media/police_logo.9ce33931.png";